import { supabase } from "../../config/supabaseClient";

export async function saveSourcesToSupabase(
  user_id: any,
  sources: any,
  username: any
) {
  for (const source of sources) {
    const { data: storedSources, error: storedSourcesError } = await supabase
      .from("traffic_sources")
      .select("*")
      .eq("user_id", user_id)
      .eq("unique_id", source.unique_id);
    if (storedSources ){
      if(storedSources.length == 0) {
        const { data: stored, error: storedError } = await supabase
        .from("traffic_sources")
        .select("*")
        .eq("user_id", user_id)
        .eq("source", source.source);
      if (stored ){
        if(stored.length == 0) {
        const { error } = await supabase
          .from("traffic_sources")
          .insert([
            {
              user_id,
              source: source.source,
              url: source.url,
              username: username,
              unique_id: source.unique_id,
            },
          ]);
        if (error) {
          console.error("Failed to save sources:", error.message);
        }
      }}
      }else{
        const { error } = await supabase
          .from("traffic_sources")
          .update({
            source: source.source,
            url: source.url,
            username: username,
          })
          .eq("unique_id", source.unique_id)
          .eq("user_id", user_id);
        if (error) {
          console.error("Failed to save sources:", error.message);
        }
      }
    }
  }
}




export async function deleteSourcesFromSupabase(user_id: any, source: any) {
  const { error } = await supabase
    .from("traffic_sources")
    .delete()
    .eq("unique_id", source.unique_id)
    .eq("user_id", user_id);
  if (error) {
    console.error("Failed to delete sources:", error.message);
  }
}